import { Box, keyframes, styled } from "@mui/material";

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-8px); }
`;

const StyledDot = styled("div")(({ theme, delay }) => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: theme.palette.primary.main,
  animation: `${bounce} 1.2s infinite ease-in-out`,
  animationDelay: delay,
}));

const StyledBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export { StyledDot, StyledBox };
